import Button from '@zeptonow/zui/Button';
import Typography from '@zeptonow/zui/Typography';
import React, { ReactNode } from 'react';
import { generateImage } from '../../utils/generateImage';
export interface EmptyScreenProps {
  buttonText?: string;
  buttonHandler?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  heading: string;
  icon?: ReactNode;
  buttonSuffixIcon?: ReactNode;
  subheading?: string;
  showButton?: boolean;
  hideIcon?: boolean;
  wrapperClass?: string;
}

const EmptyScreen: React.FC<EmptyScreenProps> = ({
  buttonText,
  heading,
  buttonHandler,
  icon,
  buttonSuffixIcon,
  subheading,
  showButton = true,
  hideIcon,
  wrapperClass,
}) => {
  return (
    <div className={`flex flex-col items-center ${wrapperClass}`}>
      <div>
        {!hideIcon &&
          (icon ??
            generateImage({
              name: 'empty',
              alt: 'empty icon',
              className: 'h-16 w-16 mb-4',
            }))}
      </div>
      <Typography variant="h6" className="text-gray-900 !mb-2">
        {heading}
      </Typography>
      {subheading && (
        <Typography variant="body1" className="text-gray-500">
          {subheading}
        </Typography>
      )}
      {showButton && (
        <Button
          variant="contained"
          onClick={buttonHandler}
          className="!w-32 !mt-4 !min-w-fit"
          startIcon={
            buttonSuffixIcon ??
            generateImage({
              name: 'plus',
              alt: 'plus icon',
              className: 'w-4 h-4',
            })
          }
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default EmptyScreen;
